import React from "react";
import { CardData } from "../datafiles/CardData";
import CustomButton from "./CustomButton";

const Cards = () => {
  return (
    <div className="flex flex-col items-center justify-center mt-[2em]">
      {CardData.map((item, index) => (
        <div key={index} className="rounded-lg border bg-[#FFFBF5] border-gray-400 p-4 hover:shadow-2xl w-[80%] h-auto mb-[4em]">
            <div>
              <img
                src={item.imgUrl}
                className="w-full mb-[1em] mt-[0.2em] object-contain border-[1px] rounded"
                alt={item.title}
              />
              <div className="mb-[1.2em] w-full flex flex-col justify-center items-center">
                <p className="font-semibold font-suwannaphum mb-[0.5em] text-[1.5em] self-start">{item.title}</p>
                <p className="font-thin font-viaoda">{item.description}</p>
              </div>
              <a
                href={item.projectUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', } } 
              >
                <CustomButton
                  title="View Project"
                  styles='border border-black align-center font-suwannaphum text-black hover:bg-gray-400 w-full'
                />
              </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Cards;
